import {BaseFlowStore} from "../base-flow-store";

/**
 * DigitalCreditAppFlowStore extends the BaseFlowStore which contains common functionality shared between flows
 */
export class DigitalCreditAppFlowStore extends BaseFlowStore {

    constructor(props) {
        super(props);
        const {match} = props;
        if (match?.params?.subRoute === "decisioning" && match?.params?.appUuid) {
            this.applicationUuid = match.params.appUuid;
        }
    }

/**
      * Redirects to the next step in the flow
      *
      *  - flowStepName: the name of the step to redirect to
      */
    handleStepRedirection = (flowStepName) => {
        switch (flowStepName) {
            case "coapplicant":
                this.historyStore.history.push(this.getPrequalUrl("/coapplicant") + `?flowUuid=${this.applicationUuid}`);
                return;

            case "decisioning":
                this.historyStore.history.push(this.getPrequalUrl(`/decisioning/${this.applicationUuid}`));
                return;

            case "done":
                this.historyStore.history.push(this.getPrequalUrl("/confirmation"));
                return;

            case "error":
                this.showServerErrorView("Failed to process application. Please try again.");
                return;

            default:
                const metadata = {
                    flowStepName,
                    applicationUuid: this.applicationUuid,
                    primaryApplicantUuid: this.primaryApplicantUuid,
                }
                console.error(`Unknown flow step name: ${flowStepName}, has to be implemented in handleStepRedirection`, metadata);
        }
    }

}
